// extracted by mini-css-extract-plugin
export default {"tertiaryBtn":"tertiary-button_tertiaryBtn__W8V1J","tertiaryBtnText":"tertiary-button_tertiaryBtnText__XxA-V","iconOnly":"tertiary-button_iconOnly__zOdst"};